// extracted by mini-css-extract-plugin
module.exports = {"root":"SqlQueryRow_root__30T2g","query":"SqlQueryRow_query__yyF9M","time":"SqlQueryRow_time__2RkCq"};